import React, { useState , useRef } from "react";
import "../Category2/Roof_waterproofing_bituminous_sheets.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';


export default function Polyurethane_sealant() {


  return (

    <div className="Roof_waterproofing_bituminous_sheets-page">
      <div className="Roof_waterproofing_bituminous_sheets-hero">
        <div className="Roof_waterproofing_bituminous_sheets-overlay">
          <h1>           איטום בפוליאוריטן - כל מה שצריך לדעת    </h1>
        </div>
<div>
</div>
</div>
    <div className="page6">
 <div className="breadcrumb6">
  <Link to="/">בית</Link> /{" "}
   <Link to="/Polyurethane_sealant">   איטום בפוליאוריטן - כל מה שצריך לדעת   </Link>{" "}
</div>
    </div>

      {/* CONTENT */}
<div className="page6">
  <div className="container">

    <div className="content-row2">


      <div className="image-box">
        <img src="/images/73.jpg" alt="roof" />
      </div>

      <div className="text-box">
<p>
איטום גגות עם פוליאוריטן נפוץ במיוחד כבר שנים רבות, אך אין מדובר בחומר איטום גגות חדש מסוגו. למעשה, חומר הפוליאוריטן קיים כבר למעלה מ-60 שנים, כאשר הייחוד העיקרי שלו הוא בכך שמדובר בחומר צפוף מאוד ודחוס. זכרו, איטום גגות מוצלח יוביל לחורף שקט, חמים ונעים!


</p>




<p>

כאשר מדברים על נושא של איטום גגות, חשוב מאוד להסתייע באנשי מקצוע איכותיים. אין יותר כיף מאשר זמן בילוי איכותי עם המשפחה, אך לפעמים הרגעים המתוקים הללו של החיים עשויים להיהרס בעקבות נזילה מעצבנת שמטפטפת בדיוק על ראשנו. חברות איטום מומלצות משתמשות גם בשיטת איטום גג עם פוליאוריטן, וזאת בעקבות העובדה שמדובר בחומר מאוד דחוס שאינו מאפשר חדירה של מים. יחד עם זאת, מדובר בחומר איטום גג שמהווה בידוד מעולה. כידוע, ככל שהבידוד בבית יהיה טוב יותר, ככה המזגן שלנו יעבוד פחות קשה. במילים אחרות, איטום גגות לא מקצועי עשוי להוביל לבידוד לא טוב, מה שיוביל לחשבון חשמל גבוה, לבית חם וגם לחדירת מים פוטנציאלית בחורף.


</p>


      </div>

    </div>


    <div className="bottom-text">

 <h2 className="main-title">
איטום גג עם פוליאוריטן


    </h2>
<p>

לא פעם, עבודת איטום גגות שנראית מקצועית בקיץ, עשויה לאכזב כאשר החורף מתחיל. איטום בפוליאוריטן מוקצף מתבצע על ידי אוטמי גגות מקצועיים, וכדאי לבצע את עבודת איטום הגג בקיץ. בקיץ עבודת איטום בפוליאוריטן תהיה זולה יותר, וזאת בעקבות 2 סיבות מרכזיות.

</p>

<p>

היות ובחורף הנזילות מתגלות, קיימות הרבה קריאות עבור עבודת איטום גג עם פוליאוריטן, מה שגורם לחברות איטום גגות לגבות מחירים גבוהים יותר. מעבר לכך, איטום בפוליאוריטן מוקצף בעונת החורף מצריך עבודה הרבה יותר מאתגרת ומורכבת. היות וחומר הבפוליאוריטן מאופיין בצפיפות גבוהה מאוד, הוא גם מונע חדירה של מים, שפשוט לא מסוגלים לחלחל דרכו.


</p>

 <h2 className="main-title">
מה הוא חומר פוליאוריטן?


    </h2>


<p>

מדובר בסוג חומר המבצע 2 פעולות עיקריות בפעם אחת, כאשר הפעולה הראשונה היא איטום והפעולה השנייה היא בידוד. במקרים רבים יש גם צורך ליצור שכבת בידוד נוספת, וכדאי תמיד להסתייע בחברות איטום גגות על מנת להבין אילו חומרים אינם מתנגשים עם חומרים אחרים.



</p>
<p>

במילים אחרות, לפעמים חומרי איטום מסוימים עשויים לדחות חומרי איטום אחרים, כך שבכל מקרה בו מבצעים איטום גגות, חובה לבדוק מה חומר האיטום שקיים כרגע על גג המבנה. במקרים בהם מתקינים חומרי איטום חדשים על חומרי איטום ישנים, בדרך כלל מה שיקרה זה, שמים יחלחלו והבידוד לא יהיה מוצלח. יחד עם זאת, גם חשוב לזכור שלפני תהליך איטום גגות, חובה לבצע הסרה של כל מכשול (כמו למשל מרזבים).  איטום גג עם פוליאוריטן מצריך הבנה עמוקה וידע בנושא, כך שלרוב לא יהיה מומלץלבצע איטום גגות באופן עצמאי. 




</p>



    </div>



    <ContactSection2/>
<div className="links2">


  <Link to="/Work_at_Height_Training" className="link-right" >  הדרכות עבודה בגובה </Link>
  <Link to="/Choosing_a_company_for_abseiling_work" className="link-left" >  בחירת חברה לעבודות סנפלינג  </Link>


</div>

      </div>
    </div>
  

      </div>
  );
}


